export const orderActionTypes = {
  START_ADD_ORDER: "START_ADD_ORDER",
  ADD_ORDER_SUCCESS: "ADD_ORDER_SUCCESS",
  ADD_ORDER_FAILURE: "ADD_ORDER_FAILURE",

  START_UPDATE_ORDER: "START_UPDATE_ORDER",
  UPDATE_ORDER_SUCCESS: "UPDATE_ORDER_SUCCESS",
  UPDATE_ORDER_FAILURE: "UPDATE_ORDER_FAILURE",

  START_DELETE_ORDER: "START_DELETE_ORDER",
  DELETE_ORDER_SUCCESS: "DELETE_ORDER_SUCCESS",
  DELETE_ORDER_FAILURE: "DELETE_ORDER_FAILURE",

  START_GET_ORDER_BY_ID: "START_GET_ORDER_BY_ID",
  GET_ORDER_BY_ID_SUCCESS: "GET_ORDER_BY_ID_SUCCESS",
  GET_ORDER_BY_ID_FAILURE: "GET_ORDER_BY_ID_FAILURE",

  START_GET_ORDERS: "START_GET_ORDERS",
  GET_ORDERS_SUCCESS: "GET_ORDERS_SUCCESS",
  GET_ORDERS_FAILURE: "GET_ORDERS_FAILURE",

  START_UPDATE_ORDER_PAYMENT_SUCCESS: "START_UPDATE_ORDER_PAYMENT_SUCCESS",
  UPDATE_ORDER_PAYMENT_SUCCESS: "UPDATE_ORDER_PAYMENT_SUCCESS",
  UPDATE_ORDER_PAYMENT_FAILURE: "UPDATE_ORDER_PAYMENT_FAILURE",
};
